'use client';

import React, { useState } from 'react';
import { MapPin, ArrowRight } from 'lucide-react';
import { Input } from '../form_base';
import { Button } from '../button';
import Rating from './rating';
import { CardContent, CardFooter } from '../card';
import { Answer } from './hero_card_client_content';

interface InitialCardContentProps {
  readonly goToNextStep: () => void;
  readonly onSubmit: (answers: Answer[]) => void;
}

export default function InitialCardContent({
  goToNextStep,
  onSubmit,
}: InitialCardContentProps) {
  const [zipCode, setZipCode] = useState('');
  const [error, setError] = useState('');

  const handleZipSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (/^\d{5}$/.test(zipCode)) {
      setError('');
      onSubmit([{ attributeName: 'zipCode', value: zipCode }]);
      goToNextStep();
    } else {
      setError('Please enter a valid 5-digit zip code');
    }
  };

  return (
    <>
      <CardContent className="flex-grow pt-4 pb-2 px-6">
        <form onSubmit={handleZipSubmit} className="space-y-6">
          <div className="space-y-2">
            <label
              htmlFor="zipCode"
              className="text-md font-semibold text-slate-800 tracking-wide"
            >
              Enter Your ZIP Code
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <MapPin className="h-5 w-5 text-emerald-500" />
              </div>
              <Input
                id="input-zip"
                type="tel"
                placeholder="e.g. 90210"
                value={zipCode}
                onChange={e => setZipCode(e.target.value)}
                className="pl-10 shadow-sm focus:ring-2 focus:ring-emerald-400"
                maxLength={5}
              />
            </div>
            {error && <p className="text-sm text-red-500">{error}</p>}
          </div>

          <Button
            type="submit"
            className="w-full bg-emerald-600 hover:bg-emerald-700 transition-colors shadow-md font-bold text-xl"
          >
            Let&rsquo;s Go <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </form>
      </CardContent>
      <CardFooter className="px-6 pb-5 text-center">
        <Rating />
      </CardFooter>
    </>
  );
}
